import axios from "axios";
import {atob} from "abab";

export default function interceptor() {
    axios.interceptors.request.use(function (config) {
        if (sessionStorage.getItem('accessToken')) {
            const token = atob(sessionStorage.getItem('accessToken'));
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });
    axios.interceptors.response.use(function (config) {
        return config;
    }, function (err) {
        return Promise.reject(err);
    });
}